import React from "react";

function RightChevronIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFF">
      <path d="M530-481 332-679l43-43 241 241-241 241-43-43 198-198Z"/>
    </svg>
  )

}

export default React.memo(RightChevronIcon);